<template>
    <v-container fluid grid-list-md>
        <v-layout column wrap>
            <v-flex>
                <h1 class="display-3">Generación de informe de costos</h1>
                <br>
                <v-card>
                    <v-card-text>
                        <v-layout>
                            <v-flex>
                                <v-btn color="primary" @click.native="generar()" :loading="loading">Informe de costos</v-btn>
                            </v-flex>
                            <v-flex>
                                <v-btn color="primary" @click.native="verificacion()" :loading="loading">Informe de Verificación</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {mapActions} from 'vuex';
    import empresaSelect from '../../components/EmpresaSelect'
    import saveAs from 'file-saver';

    export default {
        name: "costo-informe",
        components: {empresaSelect},
        data() {
            return {
                loading: false,
                progreso: 0
            }
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            generar() {
                this.loading = true;
                this.$http({
                    method: 'post',
                    url: 'indicadores/costo/excel',
                    headers: {'Content-Type': 'application/json', 'Accept': 'application/vnd.ms-excel'},
                    responseType: "blob"
                })
                    .then((response) => {
                        saveAs(response.data, 'costos.xlsx');
                        this.loading = false;
                    })
                    .catch((error) => {
                        alert(error);
                        this.loading = false;
                    });
            },
            verificacion() {
                this.loading = true;
                this.$http({
                    method: 'post',
                    url: 'indicadores/costo/faltantes',
                    headers: {'Content-Type': 'application/json', 'Accept': 'application/vnd.ms-excel'},
                    responseType: "blob"
                })
                    .then((response) => {
                        saveAs(response.data, 'costos.xlsx');
                        this.loading = false;
                    })
                    .catch((error) => {
                        alert(error);
                        this.loading = false;
                    });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/indicadores/costo-informe.vue